module.exports = __webpack_public_path__ + "img/更便捷.75e404bd.png";